// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form {
  background-color: var(--login-form-bg-color);
}
.login-form__submit-button {
  background-color: var(--login-form-button-bg-color) !important;
  color: var(--login-form-button-color) !important;
  border-color: var(--login-form-button-border-color) !important;
}
.login-form__submit-button:hover {
  background-color: var(--login-form-button-bg-color-hover) !important;
  color: var(--login-form-button-color-hover) !important;
  border-color: var(--login-form-button-border-color-hover) !important;
}
.login-form--no-background {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/LoginForm/LoginForm.scss"],"names":[],"mappings":"AAAA;EACI,4CAAA;AACJ;AACI;EACI,8DAAA;EACA,gDAAA;EACA,8DAAA;AACR;AACQ;EACI,oEAAA;EACA,sDAAA;EACA,oEAAA;AACZ;AAGI;EACI,6BAAA;AADR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
